import { render, staticRenderFns } from "./IconColumns.vue?vue&type=template&id=206e0d36&"
import script from "./IconColumns.vue?vue&type=script&lang=js&"
export * from "./IconColumns.vue?vue&type=script&lang=js&"
import style0 from "./IconColumns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports